// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/back.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blessing-page {
  min-height: 100vh;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center/cover no-repeat fixed;
  position: relative;
  overflow-x: hidden;
}

/* 顶部区域 */
.blessing-top-section {
  min-height: 40vh;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px 20px;
  z-index: 3;
}

.blessing-top-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(255, 182, 193, 0.6) 0%, rgba(255, 192, 203, 0.5) 20%, rgba(255, 218, 224, 0.4) 50%, rgba(255, 240, 245, 0.3) 80%, rgba(255, 255, 255, 0.2) 100%);
  z-index: -1;
}

/* 波浪分隔 */
.blessing-wave-divider {
  position: relative;
  height: 180px;
  margin-top: -50px;
  overflow: hidden;
  z-index: 2;
}

.blessing-wave-divider svg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 180px;
}

/* 底部区域 */
.blessing-bottom-section {
  min-height: 60vh;
  position: relative;
  padding: 40px 20px;
  z-index: 3;
}

.blessing-bottom-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to top, rgba(255, 182, 193, 0.9) 0%, rgba(255, 192, 203, 0.8) 20%, rgba(255, 205, 215, 0.7) 45%, rgba(255, 228, 235, 0.5) 75%, rgba(255, 240, 245, 0.4) 100%);
  z-index: -1;
}

.blessing-container {
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
}

/* 返回按钮 */

.back-btn {
  position: absolute;
  top: 20px;
  left: 20px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  color: white;
  text-decoration: none;
  padding: 12px 20px;
  border-radius: 25px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
}

/* 标题样式 */
.blessing-title {
  font-size: 2.5rem;
  font-weight: 700;
  background: linear-gradient(45deg, #ff69b4, #ff1493, #dc143c);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.title-icon {
  color: #ff69b4;
  filter: drop-shadow(0 2px 4px rgba(255, 105, 180, 0.5));
}

/* 祝福计数器 */
.blessing-counter {
  text-align: center;
  margin-top: 10px;
}

.counter-text {
  color: rgba(255, 255, 255, 0.95);
  font-size: 1.2rem;
  font-weight: 500;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.counter-number {
  color: #ff69b4;
  font-weight: 700;
  font-size: 1.4rem;
  text-shadow: 0 2px 6px rgba(255, 105, 180, 0.6);
}

/* 祝福列表样式 */
.blessings-list {
  margin-bottom: 40px;
  max-height: 500px;
  overflow-y: auto;
  padding-right: 10px;
}

/* 加载状态 */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid #ff69b4;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-text {
  color: rgba(255, 255, 255, 0.8);
  font-size: 1rem;
  margin: 0;
}

/* 空状态 */
.empty-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.empty-text {
  color: rgba(255, 255, 255, 0.7);
  font-size: 1.1rem;
  margin: 0;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.blessings-list::-webkit-scrollbar {
  width: 6px;
}

.blessings-list::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
}

.blessings-list::-webkit-scrollbar-thumb {
  background: rgba(255, 105, 180, 0.5);
  border-radius: 3px;
}

.blessings-list::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 105, 180, 0.7);
}

/* 单个祝福项 */
.blessing-item {
  display: flex;
  gap: 15px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 20px;
  margin-bottom: 15px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.blessing-item:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(255, 105, 180, 0.2);
}

.blessing-item .blessing-emoji {
  font-size: 2.5rem;
  flex-shrink: 0;
  align-self: flex-start;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-5px); }
}

.blessing-content {
  flex: 1 1;
  text-align: left;
}

.blessing-header-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  flex-wrap: wrap;
  gap: 10px;
}

.blessing-author {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #ff69b4;
  font-weight: 600;
  font-size: 0.9rem;
}

.author-icon {
  font-size: 0.8rem;
}

.blessing-time {
  display: flex;
  align-items: center;
  gap: 5px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.8rem;
}

.time-icon {
  font-size: 0.7rem;
}

.blessing-text {
  color: rgba(255, 255, 255, 0.95);
  line-height: 1.6;
  font-size: 1rem;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

/* 表单样式 */
.blessing-form-container {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(15px);
  border-radius: 20px;
  padding: 30px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 10px 30px rgba(255, 105, 180, 0.2);
}

.form-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: rgba(255, 255, 255, 0.95);
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 25px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.form-icon {
  color: #ff69b4;
  filter: drop-shadow(0 2px 4px rgba(255, 105, 180, 0.5));
}

.blessing-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-row {
  display: flex;
  flex-direction: column;
}

.input-group {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 15px;
  color: #ff69b4;
  z-index: 2;
  font-size: 0.9rem;
}

.textarea-icon {
  top: 15px;
  align-self: flex-start;
}

.form-input, .form-textarea {
  width: 100%;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 12px;
  padding: 15px 15px 15px 45px;
  color: white;
  font-size: 1rem;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.form-input::placeholder, .form-textarea::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.form-input:focus, .form-textarea:focus {
  outline: none;
  border-color: #ff69b4;
  background: rgba(255, 255, 255, 0.25);
  box-shadow: 0 0 0 2px rgba(255, 105, 180, 0.3);
}

.form-textarea {
  resize: vertical;
  min-height: 100px;
  line-height: 1.5;
}

.submit-btn {
  background: linear-gradient(45deg, #ff69b4, #ff1493);
  border: none;
  color: white;
  padding: 15px 30px;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-shadow: 0 6px 20px rgba(255, 105, 180, 0.4);
  align-self: center;
  min-width: 150px;
}

.submit-btn:hover:not(:disabled) {
  background: linear-gradient(45deg, #ff1493, #dc143c);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(255, 105, 180, 0.6);
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.submit-btn.submitting {
  background: linear-gradient(45deg, #ccc, #999);
}

.submit-icon {
  font-size: 0.9rem;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .blessing-top-section {
    min-height: 35vh;
    padding: 30px 15px 15px;
  }
  
  .blessing-bottom-section {
    min-height: 65vh;
    padding: 30px 15px;
  }
  
  .blessing-wave-divider {
    height: 160px;
    margin-top: -40px;
  }

  .blessing-wave-divider svg {
    height: 160px;
  }
  
  .blessing-title {
    font-size: 2rem;
    gap: 10px;
  }
  
  .counter-text {
    font-size: 1.1rem;
  }
  
  .counter-number {
    font-size: 1.3rem;
  }
  
  .blessings-list {
    max-height: 400px;
  }
  
  .blessing-item {
    padding: 15px;
    gap: 12px;
  }
  
  .blessing-item .blessing-emoji {
    font-size: 2rem;
  }
  
  .blessing-header-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }
  
  .blessing-form-container {
    padding: 25px;
  }
  
  .form-title {
    font-size: 1.2rem;
  }
}

@media (max-width: 480px) {
  .blessing-top-section {
    min-height: 30vh;
    padding: 20px 10px 10px;
  }
  
  .blessing-bottom-section {
    min-height: 70vh;
    padding: 20px 10px;
  }
  
  .back-btn {
    position: relative;
    top: auto;
    left: auto;
    margin-bottom: 15px;
    display: inline-flex;
  }
  
  .blessing-title {
    font-size: 1.8rem;
    gap: 8px;
  }
  
  .counter-text {
    font-size: 1rem;
  }
  
  .counter-number {
    font-size: 1.2rem;
  }
  
  .blessings-list {
    max-height: 350px;
  }
  
  .blessing-item {
    padding: 12px;
    gap: 10px;
  }
  
  .blessing-item .blessing-emoji {
    font-size: 1.8rem;
  }
  
  .blessing-author {
    font-size: 0.8rem;
  }
  
  .blessing-time {
    font-size: 0.7rem;
  }
  
  .blessing-text {
    font-size: 0.9rem;
  }
  
  .blessing-form-container {
    padding: 20px;
  }
  
  .form-title {
    font-size: 1.1rem;
  }
  
  .form-input, .form-textarea {
    padding: 12px 12px 12px 40px;
    font-size: 0.9rem;
  }
  
  .submit-btn {
    padding: 12px 25px;
    font-size: 0.9rem;
  }
}


`, "",{"version":3,"sources":["webpack://./src/pages/BlessingPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gFAAkE;EAClE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,4LAA4L;EAC5L,WAAW;AACb;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;AACf;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yLAAyL;EACzL,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA,SAAS;;AAET;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,qCAAqC;EACrC,2BAA2B;EAC3B,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,uDAAuD;AACzD;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,SAAS;AACX;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,UAAU;AACV;EACE,aAAa;EACb,SAAS;EACT,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;;AAEA,SAAS;AACT;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;EACpD,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE;IACE,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;IAC5B,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF","sourcesContent":[".blessing-page {\n  min-height: 100vh;\n  background: url('../assets/back.jpg') center/cover no-repeat fixed;\n  position: relative;\n  overflow-x: hidden;\n}\n\n/* 顶部区域 */\n.blessing-top-section {\n  min-height: 40vh;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px 20px;\n  z-index: 3;\n}\n\n.blessing-top-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(to bottom, rgba(255, 182, 193, 0.6) 0%, rgba(255, 192, 203, 0.5) 20%, rgba(255, 218, 224, 0.4) 50%, rgba(255, 240, 245, 0.3) 80%, rgba(255, 255, 255, 0.2) 100%);\n  z-index: -1;\n}\n\n/* 波浪分隔 */\n.blessing-wave-divider {\n  position: relative;\n  height: 180px;\n  margin-top: -50px;\n  overflow: hidden;\n  z-index: 2;\n}\n\n.blessing-wave-divider svg {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 180px;\n}\n\n/* 底部区域 */\n.blessing-bottom-section {\n  min-height: 60vh;\n  position: relative;\n  padding: 40px 20px;\n  z-index: 3;\n}\n\n.blessing-bottom-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(to top, rgba(255, 182, 193, 0.9) 0%, rgba(255, 192, 203, 0.8) 20%, rgba(255, 205, 215, 0.7) 45%, rgba(255, 228, 235, 0.5) 75%, rgba(255, 240, 245, 0.4) 100%);\n  z-index: -1;\n}\n\n.blessing-container {\n  max-width: 800px;\n  width: 100%;\n  margin: 0 auto;\n}\n\n/* 返回按钮 */\n\n.back-btn {\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(10px);\n  color: white;\n  text-decoration: none;\n  padding: 12px 20px;\n  border-radius: 25px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.back-btn:hover {\n  background: rgba(255, 255, 255, 0.25);\n  transform: translateY(-2px);\n}\n\n/* 标题样式 */\n.blessing-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  background: linear-gradient(45deg, #ff69b4, #ff1493, #dc143c);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin: 20px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.title-icon {\n  color: #ff69b4;\n  filter: drop-shadow(0 2px 4px rgba(255, 105, 180, 0.5));\n}\n\n/* 祝福计数器 */\n.blessing-counter {\n  text-align: center;\n  margin-top: 10px;\n}\n\n.counter-text {\n  color: rgba(255, 255, 255, 0.95);\n  font-size: 1.2rem;\n  font-weight: 500;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.counter-number {\n  color: #ff69b4;\n  font-weight: 700;\n  font-size: 1.4rem;\n  text-shadow: 0 2px 6px rgba(255, 105, 180, 0.6);\n}\n\n/* 祝福列表样式 */\n.blessings-list {\n  margin-bottom: 40px;\n  max-height: 500px;\n  overflow-y: auto;\n  padding-right: 10px;\n}\n\n/* 加载状态 */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid rgba(255, 255, 255, 0.3);\n  border-top: 4px solid #ff69b4;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loading-text {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 1rem;\n  margin: 0;\n}\n\n/* 空状态 */\n.empty-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n}\n\n.empty-text {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 1.1rem;\n  margin: 0;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.blessings-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.blessings-list::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 3px;\n}\n\n.blessings-list::-webkit-scrollbar-thumb {\n  background: rgba(255, 105, 180, 0.5);\n  border-radius: 3px;\n}\n\n.blessings-list::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 105, 180, 0.7);\n}\n\n/* 单个祝福项 */\n.blessing-item {\n  display: flex;\n  gap: 15px;\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(10px);\n  border-radius: 15px;\n  padding: 20px;\n  margin-bottom: 15px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: all 0.3s ease;\n}\n\n.blessing-item:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(255, 105, 180, 0.2);\n}\n\n.blessing-item .blessing-emoji {\n  font-size: 2.5rem;\n  flex-shrink: 0;\n  align-self: flex-start;\n  animation: float 3s ease-in-out infinite;\n}\n\n@keyframes float {\n  0%, 100% { transform: translateY(0px); }\n  50% { transform: translateY(-5px); }\n}\n\n.blessing-content {\n  flex: 1;\n  text-align: left;\n}\n\n.blessing-header-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.blessing-author {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #ff69b4;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.author-icon {\n  font-size: 0.8rem;\n}\n\n.blessing-time {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.8rem;\n}\n\n.time-icon {\n  font-size: 0.7rem;\n}\n\n.blessing-text {\n  color: rgba(255, 255, 255, 0.95);\n  line-height: 1.6;\n  font-size: 1rem;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n/* 表单样式 */\n.blessing-form-container {\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(15px);\n  border-radius: 20px;\n  padding: 30px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 10px 30px rgba(255, 105, 180, 0.2);\n}\n\n.form-title {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  color: rgba(255, 255, 255, 0.95);\n  font-size: 1.3rem;\n  font-weight: 600;\n  margin-bottom: 25px;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.form-icon {\n  color: #ff69b4;\n  filter: drop-shadow(0 2px 4px rgba(255, 105, 180, 0.5));\n}\n\n.blessing-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.form-row {\n  display: flex;\n  flex-direction: column;\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.input-icon {\n  position: absolute;\n  left: 15px;\n  color: #ff69b4;\n  z-index: 2;\n  font-size: 0.9rem;\n}\n\n.textarea-icon {\n  top: 15px;\n  align-self: flex-start;\n}\n\n.form-input, .form-textarea {\n  width: 100%;\n  background: rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 12px;\n  padding: 15px 15px 15px 45px;\n  color: white;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n}\n\n.form-input::placeholder, .form-textarea::placeholder {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.form-input:focus, .form-textarea:focus {\n  outline: none;\n  border-color: #ff69b4;\n  background: rgba(255, 255, 255, 0.25);\n  box-shadow: 0 0 0 2px rgba(255, 105, 180, 0.3);\n}\n\n.form-textarea {\n  resize: vertical;\n  min-height: 100px;\n  line-height: 1.5;\n}\n\n.submit-btn {\n  background: linear-gradient(45deg, #ff69b4, #ff1493);\n  border: none;\n  color: white;\n  padding: 15px 30px;\n  border-radius: 25px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  box-shadow: 0 6px 20px rgba(255, 105, 180, 0.4);\n  align-self: center;\n  min-width: 150px;\n}\n\n.submit-btn:hover:not(:disabled) {\n  background: linear-gradient(45deg, #ff1493, #dc143c);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(255, 105, 180, 0.6);\n}\n\n.submit-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.submit-btn.submitting {\n  background: linear-gradient(45deg, #ccc, #999);\n}\n\n.submit-icon {\n  font-size: 0.9rem;\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .blessing-top-section {\n    min-height: 35vh;\n    padding: 30px 15px 15px;\n  }\n  \n  .blessing-bottom-section {\n    min-height: 65vh;\n    padding: 30px 15px;\n  }\n  \n  .blessing-wave-divider {\n    height: 160px;\n    margin-top: -40px;\n  }\n\n  .blessing-wave-divider svg {\n    height: 160px;\n  }\n  \n  .blessing-title {\n    font-size: 2rem;\n    gap: 10px;\n  }\n  \n  .counter-text {\n    font-size: 1.1rem;\n  }\n  \n  .counter-number {\n    font-size: 1.3rem;\n  }\n  \n  .blessings-list {\n    max-height: 400px;\n  }\n  \n  .blessing-item {\n    padding: 15px;\n    gap: 12px;\n  }\n  \n  .blessing-item .blessing-emoji {\n    font-size: 2rem;\n  }\n  \n  .blessing-header-info {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 5px;\n  }\n  \n  .blessing-form-container {\n    padding: 25px;\n  }\n  \n  .form-title {\n    font-size: 1.2rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .blessing-top-section {\n    min-height: 30vh;\n    padding: 20px 10px 10px;\n  }\n  \n  .blessing-bottom-section {\n    min-height: 70vh;\n    padding: 20px 10px;\n  }\n  \n  .back-btn {\n    position: relative;\n    top: auto;\n    left: auto;\n    margin-bottom: 15px;\n    display: inline-flex;\n  }\n  \n  .blessing-title {\n    font-size: 1.8rem;\n    gap: 8px;\n  }\n  \n  .counter-text {\n    font-size: 1rem;\n  }\n  \n  .counter-number {\n    font-size: 1.2rem;\n  }\n  \n  .blessings-list {\n    max-height: 350px;\n  }\n  \n  .blessing-item {\n    padding: 12px;\n    gap: 10px;\n  }\n  \n  .blessing-item .blessing-emoji {\n    font-size: 1.8rem;\n  }\n  \n  .blessing-author {\n    font-size: 0.8rem;\n  }\n  \n  .blessing-time {\n    font-size: 0.7rem;\n  }\n  \n  .blessing-text {\n    font-size: 0.9rem;\n  }\n  \n  .blessing-form-container {\n    padding: 20px;\n  }\n  \n  .form-title {\n    font-size: 1.1rem;\n  }\n  \n  .form-input, .form-textarea {\n    padding: 12px 12px 12px 40px;\n    font-size: 0.9rem;\n  }\n  \n  .submit-btn {\n    padding: 12px 25px;\n    font-size: 0.9rem;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
